module.exports = __webpack_public_path__ + "media/images/icon__link-6422eedfc274cb7e8bbb6879bfe3e2f6.png";